import { createSelector } from 'reselect';
import { RootState } from '../../store';

const selectGraphBarTableVisibility = (state: RootState) => state.graphBarTableVisibility;

export const selectGraphBarTableVisible = createSelector(
    selectGraphBarTableVisibility,
    (graphBarTableVisibility) => graphBarTableVisibility.visible,
);
